






































import { Component, Mixins, Prop } from "vue-property-decorator";
import RequestedDocumentProcessor from "./helpers/RequestedDocumentProcessor.vue";
import { FixedLoading } from "../system";
import { NewDocumentEditor } from "./editors";
import { DocumentEditViewMixin, DocumentParameterContainableMixin } from "./mixins";

@Component({
  components: {
    FixedLoading,
    NewDocumentEditor,
    RequestedDocumentProcessor,
  },
})
export default class NewDocumentEditView extends Mixins(DocumentEditViewMixin, DocumentParameterContainableMixin) {
  @Prop()
  folderId: string;

  @Prop()
  defaultFormatTabName: string;

  @Prop()
  documentKindIds: number[];

  @Prop()
  formatId: number;

  @Prop()
  formatIds: number[];

  @Prop({ default: null })
  formatName: string;

  @Prop()
  chainedFormatIds: number[];

  @Prop()
  institutionNo: string;

  @Prop()
  regionalInstitutionNo: string;

  @Prop()
  hisInfoGetterParameter: string;

  @Prop()
  systemKey: string;

  @Prop()
  linkKey: string;

  @Prop()
  orderNo: string;

  @Prop()
  postRegistrationProcess: (id: number) => Promise<void>;

  @Prop({ default: false })
  shouldValidateExistingLinkedDocument: boolean;

  $refs!: {
    processor: RequestedDocumentProcessor;
  };

  async validateSelectedFormat(format: any): Promise<boolean> {
    return this.validateFormat(format, false);
  }

  validateSelectedFormatWriteMethod(format: any): boolean {
    return this.validateFormatWriteMethod(format, false);
  }
}
